import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';


export default class BilanturiRow extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

            bilantRow: {},
            idx: 0,
            totalRows: this.props.bilanturiRows.length
        }
    }

    componentDidMount() {
        this.getData()
    }


    ws = new Ws()

    getData = async () => {

        // [id] [int] IDENTITY(1,1) NOT NULL,
        // [id_head] [int] NOT NULL,
        // [capitol] [varchar](900) NULL,
        // [subcapitol] [varchar](900) NULL,
        // [descriere] [varchar](900) NULL,
        // [obs] [varchar](900) NULL,
        // [nr_crt] [varchar](900) NULL,
        // [nr_rd] [varchar](900) NULL,
        // [sold_initial] [decimal](12, 2) NULL,
        // [sold_final] [decimal](12, 2) NULL,
        // [sters] [tinyint] NULL,
        // [js_id] [varchar](32) NULL

        console.log('this.props.bilanturiRows[this.state.idx] :>> ', this.props.bilanturiRows[this.state.idx]);

        let getBilantRow = await this.ws.customSelect('select * from fin_import_bilant_rows where id_head = @p1 and js_id = @p2', {
            p1: this.props.idHead,
            p2: this.props.bilanturiRows[this.state.idx]['jsId']
        })


        console.log('getBilantRow :>> ', getBilantRow);

        if (getBilantRow.Succes) {

            let bilantRow

            if (getBilantRow.Content.length > 0) {
                bilantRow = getBilantRow.Content[0]
            } else {
                bilantRow = {
                    id: -1,
                    id_head: this.props.idHead,
                    descriere: this.props.bilanturiRows[this.state.idx]['bilantDescription'],
                    sold_initial: this.props.bilanturiRows[this.state.idx]['soldInitial'],
                    sold_final: this.props.bilanturiRows[this.state.idx]['soldFinal'],
                    js_id:this.props.bilanturiRows[this.state.idx]['jsId']
                }
            }






            this.setState({ bilantRow: bilantRow })
        }

    }


    changeBilant = (ev) => {

        let bilant = { ...this.state.bilantRow }

        let v = ev.target.value
        let n = ev.target.name


        bilant[n] = v

        this.setState({ bilantRow: bilant })


    }

    maiDeparte = async () => {


        let bilant = {
            id_head: this.state.bilantRow.id_head,
            descriere: this.state.bilantRow.descriere,
            js_id: this.state.bilantRow.js_id,
            sold_initial: this.state.bilantRow.sold_initial,
            sold_final: this.state.bilantRow.sold_final
        }

        console.log('bilant :>> ', bilant);
        if ((this.state.idx + 1) === this.state.totalRows) {

            this.props.goToFinalizeaza()

        } else {

            if (this.state.bilantRow.id === -1) {
                let insertBilantRow = await this.ws.insert('fin_import_bilant_rows', bilant)

                if (insertBilantRow.Succes) {
                    this.setState({ idx: this.state.idx + 1 }, () => {
                        this.getData()
                    })
                }
            } else {
                let updateBilantRow = await this.ws.update('fin_import_bilant_rows', {
                    sold_initial: this.state.bilantRow.sold_initial,
                    sold_final: this.state.bilantRow.sold_final
                }, {id:this.state.bilantRow.id})


                if (updateBilantRow.Succes) {
                    this.setState({ idx: this.state.idx + 1 }, () => {
                        this.getData()
                    })
                }

            }


        }

    }


    inapoi = () => {

        if ((this.state.idx - 1) >= 0) {
            this.setState({ idx: this.state.idx - 1 }, () => {
                this.getData()
            })
        } else {
            this.props.goBackToBilant()
        }
    }


    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.props.bilanturiRows[this.state.idx].bilantDescription}</h5>


                        </Grid>

                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                            <h5>{this.state.idx + 1} din {this.state.totalRows}</h5>



                        </Grid>

                    </Grid>

                    <Divider className='pm-divider' />
                </Grid>

                <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>

                        <Grid style={{textAlign: 'left'}} item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <span style={{fontSize:14, wordBreak:'break-all'}}>Introdu {this.state.bilantRow.descriere}</span>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                <input
                                    style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                    id='sold_initial'
                                    type="text"
                                    step='any'
                                    className='add-project-input'
                                    placeholder={'Ex: 2223 lei'}
                                    margin="normal"
                                    name='sold_initial'
                                    value={this.state.bilantRow.sold_initial || ''}
                                    onChange={this.changeBilant}
                                // onBlur={this.props.updateAngajatData}
                                />
                                <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.valoareInceput}</label>
                            </div>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                <input
                                    style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                    id='sold_final'
                                    type="text"
                                    step='any'
                                    className='add-project-input'
                                    placeholder={'Ex: 2223 lei'}
                                    margin="normal"
                                    name='sold_final'
                                    value={this.state.bilantRow.sold_final || ''}
                                    onChange={this.changeBilant}
                                // onBlur={this.props.updateAngajatData}
                                />
                                <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.valoareSfarsit}</label>
                            </div>
                        </Grid>

                    </Grid>
                    <Divider className='pm-divider'  style={{marginTop:20}} />

                    <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={this.maiDeparte}  >

                        {this.dictionary.financiar.maiDeparte}
                        </Button>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'inapoi-button-blue'} onClick={this.inapoi}  >

                            <i style={{
                                fontSize: 14,
                                marginRight: 10
                            }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                        </Button>

                    </Grid>
                </Grid>


            </Grid>
        );
    }
}